import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getFeedingSiloList,
	addNewFeedingSilo,
	updateFeedingSilo,
	deleteFeedingSilo,
	getFeedingSilo,
} from '../feedingSilo/thunk';

export const initialState = {
	itemFeedingSiloList: [],
	itemFeedingSiloDetail: null,
	isFeedingSiloLoading: false,
	isFeedingSiloSuccess: false,


	feedingSiloList: [],
	feedingSiloListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,

	isLoading: false,
	isSuccess: false,
	isError: false,
	error: ""
};

const FeedingSiloSlice = createSlice({
	name: 'FeedingSilo',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getFeedingSilo.fulfilled, (state, action) => {
			state.isFeedingSiloLoading = false;
			state.isFeedingSiloSuccess = true;
			state.itemFeedingSiloDetail = action.payload;
			state.isLoadingList = false;
			
			state.isLoading = false;
			state.isSuccess = true;
		});
		builder.addCase(getFeedingSilo.pending, state => {
			state.isFeedingSiloLoading = true;
			state.isFeedingSiloSuccess = null;
			state.error = null;
			state.isLoadingList = true;
			
			state.isLoading = true;
			state.isSuccess = false;
			state.error = null;
		});
		builder.addCase(getFeedingSilo.rejected, (state, action) => {
			state.isFeedingSiloLoading = false;
			state.isFeedingSiloSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
			
			state.isLoading = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.error.message;
		});

		builder.addCase(getFeedingSiloList.pending, state => {
			state.isFeedingSiloSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getFeedingSiloList.fulfilled, (state, action) => {
			state.itemFeedingSiloList = action.payload;
			state.feedingSiloList = action.payload;
			state.isLoadingList = false;
			state.isFeedingSiloSuccess = true;

			let feedingSiloListSelect = [];
			action.payload.map(item =>
				feedingSiloListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.feedingSiloListSelect = feedingSiloListSelect;
		});
		builder.addCase(getFeedingSiloList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isFeedingSiloSuccess = true;
		});
		builder.addCase(addNewFeedingSilo.fulfilled, (state, action) => {
			state.itemFeedingSiloList.push(action.payload);
			state.feedingSiloList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewFeedingSilo.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewFeedingSilo.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateFeedingSilo.fulfilled, (state, action) => {
			state.itemFeedingSiloList = state.itemFeedingSiloList.map(feedingSilo =>
				feedingSilo.feedingSiloname === action.payload.old_feedingSilo
					? { ...feedingSilo, ...action.payload.updated_feedingSilo }
					: feedingSilo
			);
			state.feedingSiloList = state.feedingSiloList.map(feedingSilo =>
				feedingSilo._id.toString() === action.payload._id.toString()
					? { ...feedingSilo, ...action.payload }
					: feedingSilo
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateFeedingSilo.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateFeedingSilo.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteFeedingSilo.fulfilled, (state, action) => {
			state.itemFeedingSiloList = current(state.itemFeedingSiloList).filter(
				item => item._id !== action.payload._id
			);
			state.feedingSiloList = current(state.feedingSiloList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteFeedingSilo.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteFeedingSilo.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
		
	},
});

export const { setRequireCloseModal } = FeedingSiloSlice.actions;

export default FeedingSiloSlice.reducer;
